import { Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import Card from '../../common/components/Card'
import { validateEntityId, validateHpii } from '../../utils/validation-helpers/PrescriberValidate'
import { validateHpio } from '../../utils/validation-helpers/ClinicValidate'
import { renderValidatedResult } from './jsxUtilities'
import { usePrescribingLocation } from '../../features/locations/hooks/usePrescribingLocation'
import { transformAddress } from '../../utils/transformAddress'

const PrescriberDetailsPanel: FunctionComponent<unknown> = () => {
  const prescriber = useSelector(({ prescriber }: RootState) => prescriber?.prescriber)
  const { prescribingLocation } = usePrescribingLocation()

  const displayName = prescribingLocation?.name
  const displayAddress = prescribingLocation
    ? transformAddress(prescribingLocation.address_1, prescribingLocation.address_2)
    : undefined

  return (
    <VStack alignItems="stretch">
      <Heading as="h4" size="md">
        Prescriber
      </Heading>
      <Card p="3">
        {prescribingLocation ? (
          <VStack flexGrow="1" flexBasis="0" alignItems="stretch">
            <HStack>
              <Text fontWeight="bold">Clinic:</Text>
              <Text>{displayName}</Text>
            </HStack>
            {displayAddress ? (
              <HStack alignItems="flex-start">
                <Text fontWeight="bold">Address:</Text>
                <Text>{displayAddress}</Text>
              </HStack>
            ) : null}
            <HStack>
              <Text fontWeight="bold">HPI-O:</Text>
              {renderValidatedResult(
                validateHpio(prescribingLocation.hpio_number, prescribingLocation.hpio_status)
              )}
            </HStack>
            <HStack>
              <Text fontWeight="bold">Given Name:</Text>
              <Text>{prescriber?.givenNames}</Text>
            </HStack>
            <HStack>
              <Text fontWeight="bold">Family Name:</Text>
              <Text>{prescriber?.familyName}</Text>
            </HStack>
            <HStack>
              <Text fontWeight="bold">Entity Id:</Text>
              {renderValidatedResult(validateEntityId(prescriber?.entityId))}
            </HStack>
            <HStack>
              <Text fontWeight="bold">HPI-I:</Text>
              {renderValidatedResult(validateHpii(prescriber?.hpii, prescriber?.hpiiStatus))}
            </HStack>
          </VStack>
        ) : (
          <VStack flexGrow="1" flexBasis="0" alignItems="stretch">
            <HStack>
              <Text fontWeight="bold">Clinic:</Text>
              <Text>
                No Clinic Bound to this prescriber. Please contact Telecare Rxpad Support.
              </Text>
            </HStack>
          </VStack>
        )}
      </Card>
    </VStack>
  )
}

export default PrescriberDetailsPanel
